<template>
  <header id="header" class="container-fluid header">
    <div class="container">
      <div class="row justify-content-between">
        <div class="header-logo-wrapper col-auto">
          <router-link to="/" class="header-logo-link">
            <img
              class="header-logo-link-img"
              src="/images/main_logo.png"
              alt="Pilates Haven Logo"
            />
          </router-link>
        </div>
        <div class="header-navigation-wrapper col-auto">
          <MobileMenu></MobileMenu>
          <ul class="header-navigation-items">
            <li>
              <router-link class="header-navigation-items-link" to="/our-services/">
                Our Services
              </router-link>
            </li>
            <li>
              <a class="header-navigation-items-link"
              href="https://backoffice.bsport.io/login?membership=2906" target="_blank">booking & prices</a>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/about-us/">
                Jean Wilcox
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/contact-us/"
              >
                Contact Us
              </router-link>
            </li>
            <li>
              <a href="tel:01502457598" class="btn">01502457598</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from '@/components/partials/MobileMenu'

export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.header {
  background-color: $clr-theme-black;
  background-image: linear-gradient(90deg, $clr-theme-black 0, #0e313f 100%);

  .router-link-active {
    text-decoration: underline;
    text-decoration-color: $clr-theme-red;
    color: $white;
  }

  .btn {
    font-size: 16px;
  }

  padding: 18px 0;

  &-logo-link-img {
    max-width: 180px;
    max-height: 180px;
    @media screen and (min-width: $md-breakpoint) {
      max-width: 250px;
    }
  }

  &-navigation {
    &-wrapper {
      margin: 0;

      @media screen and (min-width: $lg-breakpoint) {
        margin: auto 0;
      }
    }

    &-items {
      margin: 0;
      padding: 0;
      font-size: 16px;
      list-style-type: none;
      display: none;
      justify-content: space-between;
      align-items: center;

      > li + li {
        margin-left: 2rem;
      }

      @media screen and (min-width: $lg-breakpoint) {
        display: flex;
      }

      &-link, a {
        font-weight: 700;
        color: $white;
        text-transform: uppercase;

        &:hover {
          color: $white;
          text-decoration-color: $clr-theme-red;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue